import React, { Component } from "react";
import { HashRouter } from "react-router-dom";
import App from "./App";
import ScrollToTop from "./ScrollToTop";

import { QueryClient, QueryClientProvider } from "react-query";

import { ReactQueryDevtools } from 'react-query/devtools'
const queryClient = new QueryClient()

import { Toaster } from 'react-hot-toast';

// The Main component renders one of the provided
// Routes (provided that one matches).
class Main extends Component {
  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <HashRouter>
          <ScrollToTop>
            <ReactQueryDevtools initialIsOpen={false} />
            <Toaster />
            <App />
          </ScrollToTop>
        </HashRouter>
      </QueryClientProvider>
    );
  }
}

export default Main;
